<template>
  <div class="Kanit" style="color: black">
    <div class="text-center Kanit" style="font-size: 25px; font-weight: 600">
      งานที่รอการรีวิว
    </div>
    <div class="pt-9">
      <v-card v-for="(job, k) in jobs" :key="k" outlined class="pa-2 mb-3">
        <div style="font-weight: 900; font-size: 11px; margin-bottom: 15px">
          JobID : #{{ job.orderid }} ลูกค้า {{ job.customer_name }}
        </div>
        <div class="px-3">
          <div style="display: flex; flex-direction: row">
            <div>
              <img
                style="height: 60px; width: 80px"
                :src="job.customer_profile_pic"
              />
            </div>
            <div style="align-self: center; margin-left: 20px; font-size: 10px">
              ผู้จ้าง: {{ job.customer_name }}
            </div>
          </div>
          <div style="font-size: 10px; font-weight: bold">
            <div style="font-size: 13px">รายละเอียดงาน</div>
            <div style="line-height: 15px">
              ประเภทงาน: {{ job.work_type }}<br />
              พื้นที่การทาสี: {{ job.work_area }} ตรม.<br />
              สถานที่ปฏิบัติงาน: {{ job.customer_address }}
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  props: ["value"],
  computed: {
    jobs() {
      return this.value.orderlist.filter((el) => el.status == "รอการรีวิว");
    },
    query() {
      return this.$store.state.query;
    },
    profile() {
      return this.$store.state.profile;
    },
  },
  data() {
    return {
      loading: "",
    };
  },
  methods: {},
};
</script>
